import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "coffee",
  "use": "coffee-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"coffee\">\n  <path d=\"M20,3 L4,3 L4,13 C4,15.21 5.79,17 8,17 L14,17 C16.21,17 18,15.21 18,13 L18,10 L20,10 C21.11,10 22,9.1 22,8 L22,5 C22,3.89 21.11,3 20,3 Z M20,8 L18,8 L18,5 L20,5 L20,8 Z M4,19 L20,19 L20,21 L4,21 L4,19 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol